module.exports = __webpack_public_path__ + "logo_Volkswagen-b77683d2db7f1aec2ce2a8092e055f55.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_Volkswagen.png
// module id = 1373
// module chunks = 1